import React, { Component } from 'react';
import { connect } from 'react-redux';
import { TabContent, TabPane, Nav, NavItem, NavLink } from 'reactstrap';
import classnames from 'classnames';
// import LChart from './lineChart';
// import PropTypes from 'prop-types';
import LineChart from './../../../chartUtilities/lineChart/lineChart'
import Message from './../../../utilityComponents/Message';
import Loader from './../../../utilityComponents/Loader';
import { updateGPURAMMemoryUsage,
         updateGPUAvailableRAMMemory,
         updateCPUUtilization,
         updateCPUAvailableRAMMemory,
         updateCPURAMMemoryUsage } from './../../../actions/closeLoop/performanceDashboard/performanceDashboardActions';

function GraphSkeleton(props) {
    return (
        <div className='row'>
            <div className='col-12'>
                <div className='card'>
                    <div
                        className='card-header'
                        style={{ backgroundColor: "#757AF7", color: "white" }}
                    >
                        <h6>{ props.title }</h6>
                    </div>
                    <div className='card-body'>
                        { props.loading ?
                            <Loader /> : props.error ? (
                                <Message variant={'danger'}>
                                    {props.error}
                                </Message>
                            ) : (props.xAxis.length === 0 &&
                            props.yAxis.length === 0) ?
                            ( <Message variant={'info'}>
                                No Data Available
                            </Message> ) : (
                                <LineChart
                                    title={props.title}
                                    xAxis={props.xAxis}
                                    yAxis={props.yAxis}
                                    xAxisTitle={props.xAxisTitle}
                                    yAxisTitle={props.yAxisTitle}
                                />
                            )
                         }
                    </div>
                </div>
            </div>
        </div>
    )
};


function InitialGraph(props) {
    return (
        <div className='row'>
            <div className='col-12'>
                <div className='card'>
                    <div className='card-header' style={{ backgroundColor: "#757AF7", color: "white" }}>
                        <h6>GPU Utilization</h6>
                    </div>
                    <div className='card-body'>
                        { (props.gpuUtilizationXAxis.length === 0 &&
                           props.gpuUtilizationYAxis.length === 0) ?
                            (<Message variant={'info'}>
                                No Data Available
                            </Message>) : (
                                <LineChart
                                    title={'GPU Utilization (%)'}
                                    xAxisTitle={'Time (s)'}
                                    yAxisTitle={'GPU Utilization (%)'}
                                    xAxis={props.gpuUtilizationXAxis}
                                    yAxis={props.gpuUtilizationYAxis}
                                />
                            )}
                    </div>
                </div>
            </div>
        </div>
    )
}


class Visualization extends Component {
    constructor(props) {
        super(props)
        this.state = {
            activeTab: '1'
        }
    }

    toggle = (activeTab) => {
        if (this.state.activeTab !== activeTab) {
            this.setState((prevState) => {
                return {
                    activeTab
                }
            })
        }
    }

    onTabClick = (tabName) => {
        if(this.props.testRunId && this.props.benchName) {
            if(tabName) {
                const payload = {
                    test_run_id: this.props.testRunId,
                    bench_name: this.props.benchName,
                    chart_name: tabName
                }
                if(tabName === 'gpu_utilization') {
                    console.log(tabName);
                } else if (tabName === 'gpu_ram_usage') {
                    console.log(tabName);
                    if(this.props.gpuRAMMemoryUsage.xAxis.length === 0 &&
                    this.props.gpuRAMMemoryUsage.yAxis.length === 0) {
                        this.props.updateGPURAMMemoryUsageGraph(payload);
                    }
                } else if (tabName === 'gpu_available_ram') {
                    console.log(tabName);
                    if(this.props.gpuAvailableRAMMemory.xAxis.length === 0 &&
                    this.props.gpuAvailableRAMMemory.yAxis.length === 0) {
                        this.props.updateGPUAvailableRAMMemoryGraph(payload);
                    }
                } else if (tabName === 'cpu_utilization') {
                    console.log(tabName);
                    if(this.props.cpuUtilization.xAxis.length === 0 &&
                    this.props.cpuUtilization.yAxis.length === 0) {
                        this.props.updateCPUUtilizationGraph(payload);
                    }
                } else if (tabName === 'cpu_ram_usage') {
                    console.log(tabName);
                    if(this.props.cpuRAMMemoryUsage.xAxis.length === 0 &&
                    this.props.cpuRAMMemoryUsage.yAxis.length === 0) {
                        this.props.updateCPURAMMemoryUsageGraph(payload);
                    }
                } else if (tabName === 'cpu_available_ram') {
                    console.log(tabName);
                    if(this.props.cpuAvailableRAMMemory.xAxis.length === 0 &&
                    this.props.cpuAvailableRAMMemory.yAxis.length === 0) {
                        this.props.updateCPUAvailableRAMMemoryGraph(payload);
                    }
                }
            }
        }
    }

    render() {
        console.log("props", this.props);
        const tabDisabled = (this.props.gpuRAMMemoryUsage.loading ||
            this.props.gpuAvailableRAMMemory.loading ||
            this.props.cpuUtilization.loading ||
            this.props.cpuRAMMemoryUsage.loading ||
            this.props.cpuAvailableRAMMemory.loading
        )
        return (
            <div>
                { (this.props.testRunId && this.props.benchName &&
                this.props.gpuUtilizationXAxis.length > 0 &&
                this.props.gpuUtilizationXAxis.length > 0) ?
                 <div className='row'>
                    <div className='col-12'>
                        <Nav tabs>
                            <NavItem>
                                <NavLink
                                    className={classnames({active: this.state.activeTab === '1'})}
                                    style={ this.state.activeTab === '1' ? { backgroundColor : "#B0FF44", fontWeight: 'bold' } : {} }
                                    onClick={() => { this.toggle('1'); this.onTabClick('gpu_utilization'); }}
                                    disabled={tabDisabled}
                                >
                                    GPU Utilization
                                </NavLink>
                            </NavItem>
                            <NavItem>
                                <NavLink
                                    className={classnames({active: this.state.activeTab === '2'})}
                                    style={ this.state.activeTab === '2' ? { backgroundColor : "#B0FF44", fontWeight: 'bold' } : {} }
                                    onClick={() => { this.toggle('2'); this.onTabClick('gpu_ram_usage'); }}
                                    disabled={tabDisabled}
                                >
                                    GPU RAM Usage
                                </NavLink>
                            </NavItem>
                            <NavItem>
                                <NavLink
                                    className={classnames({active: this.state.activeTab === '3'})}
                                    style={ this.state.activeTab === '3' ? { backgroundColor : "#B0FF44", fontWeight: 'bold' } : {} }
                                    onClick={() => { this.toggle('3'); this.onTabClick('gpu_available_ram') }}
                                    disabled={tabDisabled}
                                >
                                    GPU Available RAM
                                </NavLink>
                            </NavItem>
                            <NavItem>
                                <NavLink
                                    className={classnames({active: this.state.activeTab === '4'})}
                                    style={ this.state.activeTab === '4' ? { backgroundColor : "#B0FF44", fontWeight: 'bold' } : {} }
                                    onClick={() => { this.toggle('4'); this.onTabClick('cpu_utilization') }}
                                    disabled={tabDisabled}
                                >
                                    CPU Utilization
                                </NavLink>
                            </NavItem>
                            <NavItem>
                                <NavLink
                                    className={classnames({active: this.state.activeTab === '5'})}
                                    style={ this.state.activeTab === '5' ? { backgroundColor : "#B0FF44", fontWeight: 'bold' } : {} }
                                    onClick={() => { this.toggle('5'); this.onTabClick('cpu_ram_usage') }}
                                    disabled={tabDisabled}
                                >
                                    CPU RAM Usage
                                </NavLink>
                            </NavItem>
                            <NavItem>
                                <NavLink
                                    className={classnames({active: this.state.activeTab === '6'})}
                                    style={ this.state.activeTab === '6' ? { backgroundColor : "#B0FF44", fontWeight: 'bold' } : {} }
                                    onClick={() => { this.toggle('6'); this.onTabClick('cpu_available_ram') }}
                                    disabled={tabDisabled}
                                >
                                    CPU Available RAM
                                </NavLink>
                            </NavItem>
                        </Nav>
                        <TabContent activeTab={this.state.activeTab}>
                            <TabPane tabId='1'>
                                <InitialGraph
                                     gpuUtilizationXAxis={this.props.gpuUtilizationXAxis}
                                     gpuUtilizationYAxis={this.props.gpuUtilizationYAxis}
                                />
                            </TabPane>
                            <TabPane tabId='2'>
                                <GraphSkeleton
                                    title={'GPU RAM memory usage (%)'}
                                    loading={this.props.gpuRAMMemoryUsage.loading}
                                    error={this.props.gpuRAMMemoryUsage.error}
                                    xAxis={this.props.gpuRAMMemoryUsage.xAxis}
                                    xAxisTitle={'Time (s)'}
                                    yAxis={this.props.gpuRAMMemoryUsage.yAxis}
                                    yAxisTitle={'GPU RAM memory usage (%)'}
                                />
                            </TabPane>
                            <TabPane tabId='3'>
                                <GraphSkeleton
                                    title={'GPU Available RAM memory (%)'}
                                    loading={this.props.gpuAvailableRAMMemory.loading}
                                    error={this.props.gpuAvailableRAMMemory.error}
                                    xAxis={this.props.gpuAvailableRAMMemory.xAxis}
                                    xAxisTitle={'Time (s)'}
                                    yAxis={this.props.gpuAvailableRAMMemory.yAxis}
                                    yAxisTitle={'GPU Available RAM memory (%)'}
                                />
                            </TabPane>
                            <TabPane tabId='4'>
                                <GraphSkeleton
                                    title={'CPU utilization (%)'}
                                    loading={this.props.cpuUtilization.loading}
                                    error={this.props.cpuUtilization.error}
                                    xAxis={this.props.cpuUtilization.xAxis}
                                    xAxisTitle={'Time (s)'}
                                    yAxis={this.props.cpuUtilization.yAxis}
                                    yAxisTitle={'CPU utilization (%)'}
                                />
                            </TabPane>
                            <TabPane tabId='5'>
                                <GraphSkeleton
                                    title={'RAM memory usage (%)'}
                                    loading={this.props.cpuRAMMemoryUsage.loading}
                                    error={this.props.cpuRAMMemoryUsage.error}
                                    xAxis={this.props.cpuRAMMemoryUsage.xAxis}
                                    xAxisTitle={'Time (s)'}
                                    yAxis={this.props.cpuRAMMemoryUsage.yAxis}
                                    yAxisTitle={'RAM memory usage (%)'}
                                />
                            </TabPane>
                            <TabPane tabId='6'>
                                <GraphSkeleton
                                    title={'Available RAM memory (%)'}
                                    loading={this.props.cpuAvailableRAMMemory.loading}
                                    error={this.props.cpuAvailableRAMMemory.error}
                                    xAxis={this.props.cpuAvailableRAMMemory.xAxis}
                                    xAxisTitle={'Time (s)'}
                                    yAxis={this.props.cpuAvailableRAMMemory.yAxis}
                                    yAxisTitle={'Available RAM memory (%)'}
                                />
                            </TabPane>
                        </TabContent>
                    </div>
                </div> :
                <div className="alert alert-danger" role="alert">
                    No Data Available
                </div> }
            </div>
        )
    }
}
// Visualization.propTypes={
// systemPerformanceInfo:PropTypes.string,
// //items:PropTypes.string,
// }
// Visualization.defaultProps= {
// systemPerformanceInfo:[],
// //items:[],
// }
// componentDidMount() {
//     this.setState( (prevState) => {
//         if(this.props.content){
//             return{
//                 scenario_id: this.props.content.scenario_id,
//                 scenario_group_name: this.props.content.scenario_group_name,
//                 scenario_uuid: this.props.content.scenario_uuid,
//                 scenario_name: this.props.content.scenario_name
//             }
//         } else {
//             return {
//                 scenario_id: "",
//                 scenario_group_name: "",
//                 scenario_uuid: "",
//                 scenario_name: ""
//             }
//         }
//     })
// }

// onScenarioUUIDChange = (e) => {
//     const scenario_uuid = e.target.value;
//     this.setState(() => ({scenario_uuid}));
// }

// onScenarioNameChange = (e) => {
//     const scenario_name = e.target.value;
//     this.setState(() => ({scenario_name}))
// }

// onSubmit = (e) => {
//     e.preventDefault();
//     const submitValue = {
//         scenario_id: this.state.scenario_id,
//         scenario_group_name: this.state.scenario_group_name,
//         scenario_uuid: this.state.scenario_uuid,
//         scenario_name: this.state.scenario_name,
//         scenario_group_scenario_mapping_id: this.props.content.scenario_group_scenario_mapping_id,
//         sequence: this.props.content.sequence,
//         scenario_group_id: this.props.content.scenario_group_id
//     }
//     //console.log(this.state);
// //        updateScenarioGroupDetails(submitValue).then( (response)=> {
// //            console.log(response);
// //        })

//     const edit_api_url = (window.location.origin).concat('/edit')
//     const data_for_api = {
//         scenario_uuid : submitValue['scenario_uuid'],
//         scenario_description : submitValue['scenario_name']
//     }
//     editDb(edit_api_url, data_for_api).then(res => {
//         console.log("Status of updation : ", res['data']['status'])
//         if(res['data']['status'] === "Updated Successfully"){
//             this.props.dispatch(editScenarioGroupData(submitValue));
//             this.props.handleEditModalClose();
//         }

//     })

//     //this.props.dispatch(editScenarioGroupData(submitValue));
//     //this.props.handleEditModalClose();
// };


const mapStateToProps = (state) => ({
    gpuRAMMemoryUsage: state.gpuRAMUsage.gpuRAMMemoryUsage,
    gpuAvailableRAMMemory: state.gpuAvailRAM.gpuAvailableRAMMemory,
    cpuUtilization: state.cpuUtilize.cpuUtilization,
    cpuRAMMemoryUsage: state.cpuRAMUsage.cpuRAMMemoryUsage,
    cpuAvailableRAMMemory: state.cpuAvailRam.cpuAvailableRAMMemory
});

const mapStateToDispatch = (dispatch) => ({
    updateGPURAMMemoryUsageGraph: (payload) => dispatch(updateGPURAMMemoryUsage(payload)),
    updateGPUAvailableRAMMemoryGraph: (payload) => dispatch(updateGPUAvailableRAMMemory(payload)),
    updateCPUUtilizationGraph : (payload) => dispatch(updateCPUUtilization(payload)),
    updateCPUAvailableRAMMemoryGraph : (payload) => dispatch(updateCPUAvailableRAMMemory(payload)),
    updateCPURAMMemoryUsageGraph: (payload) => dispatch(updateCPURAMMemoryUsage(payload))
})

export default connect(mapStateToProps, mapStateToDispatch)(Visualization);
